module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi0-72a1e6e4428decd20846c39a87e2a938.webp";